import { useAuth } from '@/lib/auth/auth';
import { type DiscoveryEvent } from '@/lib/api/apiTypes';
import { useQuery } from '@tanstack/react-query';

interface VenueEventsResponse {
  events: DiscoveryEvent[];
}

export const venueEventKeys = {
  all: ['venue-events'] as const,
  list: (id: string) => [...venueEventKeys.all, id] as const,
};

export function useVenueEvents(id?: string | null) {
  const request = useAuth((state) => state.request);

  return useQuery({
    queryKey: id ? venueEventKeys.list(id) : venueEventKeys.all,
    enabled: Boolean(id),
    queryFn: () => {
      if (!id) {
        throw new Error('Missing venue id');
      }
      return request<VenueEventsResponse>(`/venues/${id}/events`);
    },
    staleTime: 30_000,
  });
}
